var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/question-tooltip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,5 C15.8659932,5 19,8.13400675 19,12 C19,15.8659932 15.8659932,19 12,19 C8.13400675,19 5,15.8659932 5,12 C5,8.13400675 8.13400675,5 12,5 Z M12,6.27272727 C8.83691461,6.27272727 6.27272727,8.83691461 6.27272727,12 C6.27272727,15.1630854 8.83691461,17.7272727 12,17.7272727 C15.1630854,17.7272727 17.7272727,15.1630854 17.7272727,12 C17.7272727,8.83691461 15.1630854,6.27272727 12,6.27272727 Z M12.0063636,14.5454545 C12.3578176,14.5454545 12.6427273,14.8303643 12.6427273,15.1818182 C12.6427273,15.5332721 12.3578176,15.8181818 12.0063636,15.8181818 C11.6485461,15.8181818 11.3636364,15.5332721 11.3636364,15.1818182 C11.3636364,14.8303643 11.6485461,14.5454545 12,14.5454545 Z M12.3794216,8.21561287 C13.6027601,8.42544795 14.4963932,9.4870161 14.4945505,10.7272727 C14.4945505,11.5416433 14.0120636,12.1849546 13.2566282,12.6885776 C12.8436794,12.9638765 12.4379826,13.144186 12.1503266,13.2400713 C11.816908,13.3512106 11.4565227,13.1710178 11.3453833,12.8375993 C11.2342439,12.5041808 11.4144367,12.1437954 11.7478553,12.032656 C11.7891351,12.0188961 11.8747012,11.9862995 11.9889352,11.9355289 C12.1818191,11.8498028 12.3744653,11.7470583 12.5506467,11.6296042 C12.9883944,11.3377727 13.2218203,11.0265385 13.221821,10.7263261 C13.2227442,10.1057232 12.7759269,9.57493832 12.1642573,9.47002071 C11.5525877,9.36510311 10.9544285,9.71664655 10.7484856,10.3020822 C10.6318578,10.6336208 10.2685473,10.8078405 9.93700866,10.6912128 C9.60547006,10.5745851 9.43125037,10.2112745 9.54787808,9.87973594 C9.95976392,8.70886455 11.1560824,8.00577767 12.3794216,8.21561287 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/question-tooltip",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTooltip);
export default __webpack_public_path__ + "static/media/question-tooltip.c2133cfe8147abad3c8e42389ac94414.svg";
export { ForwardRef as ReactComponent };